import { h, Component } from 'preact';
import styles from './checkbox_list_style';
import classNames from 'classnames';


export default class CheckboxList extends Component {
  componentDidMount = () => {
      this.selectedCheckboxes = new Set();
  }
  updateValue = (e) => {
    const val = e.target.value;
    if(this.selectedCheckboxes.has(val)) {
      this.selectedCheckboxes.delete(val);
    } else {
      this.selectedCheckboxes.add(val);
    }
    this.props.updateValue(Array.from(this.selectedCheckboxes).join());
  } 
  render({field, isValid},{}) {
		var classes = classNames({
      'form-control': true,
      'is-invalid': !isValid
    });
		return (
            <div>
                { field.options.map( option => (
                <div class="form-check">
                    <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" name={field.mapping} value={option.value} onChange={this.updateValue} />{option.label}
                    </label>
                </div>
                )) }
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./field_types/checkbox_list.js